export const PREVIEW = 'preview';
export const STANDARD = 'STANDARD';